export enum ReferenceTypes {
    DocumentOpenBalanceOfGood,
    DocumentRetailSalesReport,
    DocumentCashRegisterReceipt,
    DocumentClosingProfitAndLossAccounts,
    DocumentAccumulationOfDepreciation,
    DocumentAccrualOfLoanInterest,
    DocumentRecalculationOfTransactions,
    DocumentCurrencyRevaluation,
    DocumentReceiptFromProductionAndSale,
    PurchaseFromSupplier,
    DocumentSalesOrder,
    DocumentPostingOfGood,
    DocumentTransferOfGoods,
    DocumentWriteOffGood,
    DocumentAssemblyDisassemblyOfGood,
    DocumentGoodsTransferOrder,
    DocumentConsumptionOrder,
    DocumentAssemblyDisassemblyOrder,
    DocumentGoodsRegrading,
    DocumentCustomerInvoice,
    DisbursementFromBank,
    DocumentPaymentRequest,
    DocumentPurchaseOrder,
    SalesCreditNote,
    DocumentVendorInvoice,
    CatalogFixedAsset,
    CatalogAccrual,
    CatalogDevice,
    CatalogRetailSetting,
    CatalogRetailCashRegister,
    CatalogPosTerminal,
    CatalogProductBatch,
    CatalogAnalyticsTypeOfActivePassiveItem,
    CatalogAnalyticsTypeOfIncomeExpenseItem,
    CatalogBank,
    CatalogBankAccount,
    CatalogBankAccountVendorCustomer,
    CatalogBankAcquirer,
    CatalogBillOfMaterial,
    CatalogCompanyCashBox,
    CatalogCashFlowItem,
    CatalogCashRegister,
    CatalogCompany,
    CatalogContract,
    CatalogCountry,
    CatalogCurrency,
    CatalogDeduction,
    CatalogDeliveryMethod,
    CatalogDivision,
    CatalogDriver,
    CatalogFeature,
    CatalogPerson,
    CatalogPosition,
    CatalogEmployee,
    CatalogPriceType,
    CatalogProduct,
    CatalogUnit,
    CatalogVariant,
    CatalogVehicle,
    CatalogVendorCustomer,
    CatalogVendorItem,
    CatalogWarehouse,
    CatalogWithHoldingTaxRate,
    CatalogWorkSchedule,
    CatalogActivePassiveItem,
    CatalogIncomeItem,
    CatalogExpenseItem,
    CatalogCashierShift,
    CatalogTaxGroup,
    CatalogSpecification,
    CatalogCategoryOfFixedAssets,
    DocumentAcquiringOperation,
    DocumentArApOffset,
    DocumentArApWriteOff,
    DocumentCommodityWaybill,
    DocumentDepreciationCharge,
    DocumentEmployeeDismissal,
    DocumentEmployeeHire,
    DocumentEmployeeTransfer,
    DocumentEnterOfSettlementsBalance,
    DocumentExchangeDifferenceCalculation,
    DocumentExpenseBankPayment,
    DocumentExpenseCashPayment,
    DocumentFixedAssetInitialRecognition,
    DocumentIncomingBankPayment,
    DocumentIncomingCashPayment,
    DocumentProduction,
    DocumentProductPricing,
    DocumentReturnOfGoodsFromCustomer,
    DocumentReturnOfGoodsFromVendor,
    DocumentSalaryAccrual,
    DocumentStocktaking,
    Account,
    DocumentAccountingManualTransaction,
    DocumentImport,
    DocumentDistributionOfLandedCost,
    DocumentDebtCorrection,
    DocumentSetItemsPrice,
    CatalogVatArticle,
    CatalogVatType,
    CatalogConstructionObject,
    DocumentFixedAssetsTakeInAccount,
    DocumentFixedAssetsModernization,
    DocumentFixedAssetsMoving,
    DocumentFixedAssetsWriteOff,
    DocumentFixedAssetsInventory,
    DocumentSalaryPayment,
    DocumentInventoryConsumption,
    DocumentPurchaseCreditNote,
    DocumentReceivedWaybill,
    DocumentSalesCreditNote,
    DocumentIssuedTaxInvoice,
    DocumentRetailSale,
    DocumentReceiptFromProductionAndSalesWithPayment,
    DocumentProductionOverheadCostDistribution,
    DocumentProductionSalary,
    CatalogFixedAssetsCategory,
    CatalogFixedAssetsTaxGroup,
    DocumentRetailSalesReportPayment,
    DocumentSettlementVendorOpeningBalance,
    DocumentSettlementCustomerOpeningBalance,
    DocumentTaxInvoice,
    DocumentBankOpeningBalance,
    DocumentCashOpeningBalance,
    CatalogPurchaseCancellationReason,
    CatalogSalesCancellationReason,
    CatalogCustomerSettlementAnalytic,
    CatalogVendorSettlementAnalytic
}
